import { render, staticRenderFns } from "./ProductAvatar.vue?vue&type=template&id=6055fb28&scoped=true&"
import script from "./ProductAvatar.vue?vue&type=script&lang=js&"
export * from "./ProductAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProductAvatar.vue?vue&type=style&index=0&id=6055fb28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055fb28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6055fb28')) {
      api.createRecord('6055fb28', component.options)
    } else {
      api.reload('6055fb28', component.options)
    }
    module.hot.accept("./ProductAvatar.vue?vue&type=template&id=6055fb28&scoped=true&", function () {
      api.rerender('6055fb28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductAvatar.vue"
export default component.exports